export const AudioIcon = ({ className }: { className?: string }) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 8.33333L2.5 11.6667M6.25 5L6.25 15M10 2.5V17.5M13.75 5V15M17.5 8.33333V11.6667" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
};

AudioIcon.displayName = "AudioIcon";
